/* eslint-disable react-hooks/exhaustive-deps */

import OtherTaxes from "../../components/OtherTaxes";

const AdminOtherTaxes = (props) => {
    return (
        <OtherTaxes moduleType={'Admin'} {...props} />
    )
}

export default AdminOtherTaxes